<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">

    <div class="mt-6 flex items-center justify-between px-6">
        <h4> {{$t('Search')}}</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>

    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">
      <div class="p-5">
 <p class="mt-5">{{$t('Course')}}</p>
    <v-select
      label="Name"
      class="w-full"
      v-model="search.CourseID"
      :options="courses"
      autocomplete
      :reduce="Course => Course.ID"
      @input="getCourseModules(search.CourseID)"
    />
      <p class="mt-5">{{$t('CourseModules')}}</p>
        <v-select
          label="Name"
          class="w-full"
          v-model="search.CourseModuleID"
          :options="courseModules"
          :reduce="ID => ID.ID"
        />
        <!-- <vs-select autocomplete class="mt-5 w-full"  name="Course" label="Course" v-model="search.CourseID" > 
           <vs-select-item :key="index" :value="item.ID" :text="item.Name" v-for="(item,index) in courses" />
        </vs-select> -->
<p class="mt-5">{{$t('Category')}}</p>
    <v-select
      label="Name"
      class="w-full"
      v-model="search.CategoryID"
      :options="categories"
      autocomplete
      :reduce="Category => Category.ID"
    />
    
<p class="mt-5">{{$t('QuestionType')}}</p>
    <v-select
      label="Name"
      class="w-full"
      v-model="search.QuestionTypeID"
      :options="questionTypes"
      autocomplete
      :reduce="QuestionType => QuestionType.ID"
    />
  
<p class="mt-5">{{$t('QuestionLevel')}}</p>
    <v-select
      label="Name"
      class="w-full"
      v-model="search.QuestionLevelID"
      :options="questionLevels"
      autocomplete
      :reduce="QuestionLevel => QuestionLevel.ID"
    />
  
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="searchYearSummery" >{{$t('Search')}}</vs-button>
       <vs-button type="border" class="mr-6" color="danger" @click="resetModel">{{$t('Reset')}}</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">{{$t('Cancel')}}</vs-button>
    </div>

  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import moduleCourse from "@/store/course/moduleCourse.js";
import moduleQuestionLevel from "@/store/settings/questionLevel/moduleQuestionLevel.js";
import moduleQuestionType from "@/store/settings/questionType/moduleQuestionType.js";
import moduleCategory from "@/store/settings/category/moduleCategory.js";
import moduleQuestionBank from "@/store/question/questionBank/moduleQuestionBank.js";
import vSelect from 'vue-select'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    search: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      }
    };
  },

  computed: {
     courseModules() {
      return this.$store.state.questionBankList.courseModules;
    },
      questionLevels() {
      return this.$store.state.questionLevelList.questionLevels;
    },
     categories() {
      return this.$store.state.categoryList.categories;
    },
      courses() {
      
      return this.$store.state.courseList.courses;
    },
     questionTypes() {
      return this.$store.state.questionTypeList.questionTypes.filter(function(element){
        
        if(element.ID!=5&&element.ID!=4)
         return element;
      });
    },
  
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
         
        }
      }
    },
  
  },

  methods: {
      resetModel(){
      
          this.search.CourseID=null;
           this.search.CategoryID=null;
           this.search.QuestionLevelID=null;
           this.search.QuestionTypeID=null;
           this.search.CourseModuleID=null;
             this.search={};
      },
      getCourseModules(id){
      debugger;
      this.$store.dispatch("questionBankList/GetCourseModulesByCourseID",id);
     },
    searchYearSummery()
    {
      this.$emit("closeSidebar",true);
    }
  },
  created()
  {
    
     if (!moduleCourse.isRegistered) {
      this.$store.registerModule("courseList", moduleCourse);
      moduleCourse.isRegistered = true;
    }    
     if (!moduleQuestionLevel.isRegistered) {
      this.$store.registerModule("questionLevelList", moduleQuestionLevel);
      moduleQuestionLevel.isRegistered = true;
    }
     if (!moduleQuestionType.isRegistered) {
      this.$store.registerModule("questionTypeList", moduleQuestionType);
      moduleQuestionType.isRegistered = true;
    }
    if (!moduleCategory.isRegistered) {
      this.$store.registerModule("categoryList", moduleCategory);
      moduleCategory.isRegistered = true;
    }
   if (!moduleQuestionBank.isRegistered) {
      this.$store.registerModule("questionBankList", moduleQuestionBank);
      moduleQuestionBank.isRegistered = true;
    }
    
    if(this.$store.state.categoryList.categories.length==0)
      this.$store.dispatch("categoryList/fetchDataListItems");
    if(this.$store.state.courseList.courses.length==0)
      this.$store.dispatch("courseList/fetchDataListItems");
    if(this.$store.state.questionLevelList.questionLevels.length==0)
      this.$store.dispatch("questionLevelList/fetchDataListItems");
    if(this.$store.state.questionTypeList.questionTypes.length==0)
      this.$store.dispatch("questionTypeList/fetchDataListItems");
  },
  components: {
    VuePerfectScrollbar,
    vSelect
  }
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  height: calc(100% - 4.3rem);
}
</style>
